import React from 'react';
import BillingRow from './BillingRow';

const BillingLog = ({ data, invoiceData, $isMobile }) => {
  if ($isMobile) {
    return (
      <div className='relative flex flex-col items-start gap-5 pt-3'>
        {data?.length > 1 && (
          <div className='absolute left-[14px] top-[36px] bottom-[28px] w-0.5 bg-grayscale-gray02' />
        )}
        {data?.map((item) => (
          <BillingRow
            key={item.historyId}
            data={item}
            invoiceData={invoiceData}
            $isMobile
          />
        ))}
      </div>
    );
  }

  return (
    <div className='relative flex flex-col items-start p-[30px] gap-6'>
      <div className='absolute left-[49px] top-[50px] bottom-[50px] w-0.5 bg-grayscale-gray02' />
      {data?.map((item) => (
        <BillingRow
          key={item.historyId}
          data={item}
          invoiceData={invoiceData}
        />
      ))}
    </div>
  );
};

export default BillingLog;
